/* eslint no-alert:0 */

window.sh_popups = window.sh_popups || {};

export function Popup(popup_el) {
	const id = popup_el.id;

	const inner_el = popup_el.querySelector(`.inner`);
	if (!inner_el) {
		return;
	}

	function open() {
		let ev = new Event(`sh_close_popups`);
		window.dispatchEvent(ev);

		popup_el.classList.add(`open`);
		document.addEventListener(`keyup`, close_esc);
		popup_el.addEventListener(`click`, close_click);

		const lazy_els = popup_el.querySelectorAll(`iframe, img`);
		for (const lazy_el of lazy_els) {
			if (lazy_el.src) {
				continue;
			}

			const src = lazy_el.dataset.src;
			if (!src) {
				continue;
			}

			lazy_el.src = src;
		}

		ev = new CustomEvent(`sh_open_popup`, {
			detail: id,
		});
		window.dispatchEvent(ev);
	}

	function open_click(e) {
		e.preventDefault();

		open();
	}

	function close() {
		popup_el.classList.remove(`open`);
		document.removeEventListener(`keyup`, close_esc);
		popup_el.removeEventListener(`click`, close_click);
	}

	function close_esc(e) {
		if (e.keyCode === 27) {
			close();
		}
	}

	function close_click(e) {
		if (e.target.contains(popup_el)) {
			close();
		}
	}

	const open_els = document.querySelectorAll(`button[data-popup_id="${id}"], a[href$="#${id}"]`);
	for (let i = 0; i < open_els.length; i++) {
		open_els[i].addEventListener(`click`, open_click);
	}

	const close_el = popup_el.querySelector(`.btn-close`);
	if (close_el) {
		close_el.addEventListener(`click`, close);
	}

	window.addEventListener(`sh_close_popups`, close);

	window.addEventListener(`sh_open_popup_${id}`, open);

	return {
		id,
		open,
	};
}
